import BrandLogo from "@/components/BrandLogo";

const COLUMNS = [
  {
    title: "Product",
    links: [
      { label: "Overview", href: "/product" },
      { label: "AI Voice Agents", href: "/ai-voice-agents" },
      { label: "AI Marketing", href: "/ai-marketing" },
      { label: "CRM", href: "/crm" },
    ],
  },
  {
    title: "Platform",
    links: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "Pricing", href: "/#pricing" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Support", href: "/support" },
      { label: "Sign In", href: "/login" },
      { label: "Create Account", href: "/signup" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-200 bg-white text-[#111111]">
      <div className="mx-auto max-w-6xl px-5 pt-16 sm:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div className="col-span-2 md:col-span-1">
            <a href="/#top" data-testid="footer-brand" className="flex items-center gap-2.5">
              <BrandLogo />
              <span className="text-lg font-bold tracking-tight text-[#111111]">Savy Kerno</span>
            </a>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#808080]">
              One intelligent platform for AI voice agents, customer
              relationships and digital marketing.
            </p>
            <a
              href="mailto:support@savykernoai.com"
              data-testid="footer-support-email"
              className="mt-4 inline-block text-sm text-[#808080] transition-colors hover:text-[#111111]"
            >
              support@savykernoai.com
            </a>
          </div>
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="text-sm font-bold text-[#111111]">{col.title}</p>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-[#808080] transition-colors hover:text-[#111111]"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-neutral-200 pt-6 sm:flex-row">
          <p className="text-xs text-[#808080]" data-testid="footer-copyright">
            © 2026 Savy Kerno. All rights reserved.
          </p>
          <div className="flex items-center gap-5 text-xs text-[#808080]">
            <a href="/privacy" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-privacy">Privacy</a>
            <a href="/terms" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-terms">Terms</a>
            <a href="/ai-calling-policy" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-calling">AI Calling</a>
            <a href="/data-processing" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-dpa">DPA</a>
            <a href="/cookies" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-cookies">Cookies</a>
            <a href="/support" className="transition-colors hover:text-[#111111]" data-testid="footer-legal-support">Support</a>
          </div>
        </div>
      </div>
      <div className="overflow-hidden" aria-hidden="true">
        <p
          data-testid="footer-watermark"
          className="select-none whitespace-nowrap text-center"
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
            fontSize: "clamp(64px, 16vw, 280px)",
            lineHeight: 0.82,
            letterSpacing: "-0.03em",
            background: "linear-gradient(90deg, #A3A3A3 0%, #808080 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            WebkitMaskImage: "linear-gradient(180deg, rgba(0,0,0,1) 35%, rgba(0,0,0,0) 98%)",
            maskImage: "linear-gradient(180deg, rgba(0,0,0,1) 35%, rgba(0,0,0,0) 98%)",
            marginBottom: "-0.06em",
          }}
        >
          SAVY KERNO
        </p>
      </div>
    </footer>
  );
}
